export const CUSTOM_EVENT_KEY_CODE = 0
